import styled, { createGlobalStyle } from 'styled-components';
import { primaryColor } from '~/Styles';
export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap');
`;

export const ProspectoData = styled.div`
  margin-top: 5px;
  @media screen and (min-width: 576px) and (max-width: 768px) {
    margin-top: 0px;
  }
  font-size: 10px;
  color: #666;
  line-height: 1;
`;

export const ProspectoNome = styled.div`
  font-weight: 700;
`;

export const ProspectoContato = styled.div`
  display: flex;
  align-items: center;
`;

export const ProspectoContainer = styled.div.attrs({
  className: 'mb-2 arrow-bottom-left',
})`
  & {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff;
    border-radius: 2px;
    position: relative;

    ${props => props.isActive && `box-shadow: 0 0 0 2px ${primaryColor};`}

    ${ProspectoNome} {
      color: ${props => (props.isActive ? primaryColor : 'inherit')};
    }
    &&::before {
      border-left-color: ${props => props.corImobiliaria || '#ccc'};
    }

    .prospect-name {
      color: ${primaryColor};
      font-weight: 500;
    }

    button {
      border: 0;
      background: 0;
      text-align: left;
      padding: 0;
      &,
      &:focus {
        outline-width: 0;
      }
      &:hover {
        color: ${primaryColor};
      }
    }

    ul {
      li {
        display: flex;
        flex-direction: column;
        line-height: 1;
        small {
          font-size: 12px;
          color: #666;
        }
        strong {
          font-size: 0.8rem;
        }
      }
    }
  }
`;

export const TagStatus = styled.div.attrs({
  className: 'rounded position-absolute',
})`
  right: 0.5rem;
  top: 0.5rem;
  font-size: 60%;
  padding: 0.1rem 0.6rem 0.08rem;
  border: 1px solid ${props => props.CorStatus};
  color: ${props => props.CorStatus};
`;

export const OpenSansMuted = styled.div`
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  font-size: 0.8rem;
  color: #7b8ca6;
  font-weight: 400;
`;

export const VerticalDivider = styled.div`
  height: 32px;
  width: 1px;
  background: #293c66;
  margin: 0 12px;
  align-self: left;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Linha = styled.div`
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 12px 16px;
  box-shadow: 0 1px 2px rgba(44, 62, 80, 0.04);
  border: 1px solid #f0f0f0;
  font-family: 'Open Sans', Arial, sans-serif;
`;

export const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #bcd6f7;
  color: #3a5ca8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.2rem;
  margin-right: 16px;
`;

export const Nome = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 0.8rem;
`;

export const Email = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 0.65rem;
  color: #7b8ca6;
`;

export const StatusTag = styled.span`
  color: #fff;
  border-radius: 8px;
  padding: 2px 10px;
  font-size: 0.7rem;
  font-weight: 500;
`;

export const Data = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  color: #7b8ca6;
  margin-bottom: 2px;
  svg {
    margin-right: 4px;
    color: #2196f3;
  }
`;

export const AcoesMenu = styled.div`
  position: relative;
  .acoes-dropdown {
    display: ${props => (props.show ? 'block' : 'none')};
    position: absolute;
    left: 0;
    right: 0;
    top: 26px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(44, 62, 80, 0.08);
    z-index: 10;
    min-width: 190px;
  } 


   .acoes-item:hover .dropdown-label {
    background-color: #58d0ff;
    color: white;
    }

.dropdown-label {
    display: block;
    width: 100%;
    padding: 0.4rem 0.8rem;
    border-radius: 6px;
    background-color: transparent;
    transition: all 0.2s ease;
    font-weight: 500;
  }
  .acoes-item {
    background-color: transparent !important;
    padding: 0.3rem 0.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    
  }
  }
`;
